import React, { createContext, useContext, useEffect, useState } from 'react';
import { IStaticFilesContext } from './types/static-files-context';
import WebFontLoader from 'webfontloader';

export const StaticFilesContext = createContext<IStaticFilesContext>(null!);

export function StaticFilesProvider(props: React.PropsWithChildren<unknown>) {
    const [ready, setReady] = useState<boolean>(false);

    useEffect(() => {
        loadFonts();
    }, [])

    const loadFonts = async () : Promise<void> => {
        WebFontLoader.load({
            timeout: 3000,
            google: {
                families: ['Roboto:400,500,600', 'Roboto-Regular:400,500,600']
            },
            active: () => {
                setReady(true);
            },
            inactive: () => {
                // do not raise error if fonts were not loaded for some reason
                // just show a notification in the console.
                console.warn("StaticFilesProvider - fonts were not loaded.")
                setReady(true);
            }
        });
    }

    const contextValue = {
        ready: ready
    } as IStaticFilesContext;

    return <StaticFilesContext.Provider value={{ ...contextValue }}>{props.children}</StaticFilesContext.Provider>;
}

export function useStaticFiles() {
    const context = useContext(StaticFilesContext);

    if (!context) {
        throw new Error('useStaticFiles must be used within the StaticFilesProvider');
    }

    return context;
}
